import './travel-extension-details.scss';

class TravelExtensionDetails {
    constructor (element) {
        this.$root = element;
        this.$shareDetails = this.$root.querySelector('[data-travel-extension-share-url]');
        this.$printDetails = this.$root.querySelector('[data-travel-extension-print-url]');
    }

    initialize () {
        if (this.$shareDetails) {
            this.$shareDetails.onclick = () => {
                this.setActive(this.$shareDetails);
                navigator.clipboard.writeText(this.$shareDetails.dataset.travelExtensionShareUrl);
            };
        }

        if (this.$printDetails) {
            this.$printContent = null;
            this.fetchPrintContent(this.$printDetails.dataset.travelExtensionPrintUrl);

            this.$printDetails.onclick = () => {
                this.setActive(this.$printDetails);
                this.printOverlay(this.$printDetails.dataset.travelExtensionPrintUrl);
            };
        }
    }

    setActive ($cta) {
        let active = true;

        setTimeout(() => {
            active = false;
        }, 1000);

        $cta.setAttribute('aria-pressed', active);
    }

    fetchPrintContent (fetchUrl) {
        fetch(fetchUrl, {
            method: 'POST',
            body: new FormData(this.$form)
        })
            .then(response => response.text())
            .then(data => {
                const parser = new DOMParser();
                const parsedData = parser.parseFromString(data, 'text/html');

                const $mainContent = parsedData.querySelector('[data-main-content]');

                if ($mainContent) {
                    this.$printContent = $mainContent.innerHTML;
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    printOverlay (fetchUrl) {
        const $printContainer = document.querySelector('[data-print-content]');

        if (!$printContainer) {
            return;
        }

        if (this.$printContent === null) {
            this.fetchAndPrint(fetchUrl, $printContainer);
            return;
        }

        this.print($printContainer, this.$printContent);
    }

    fetchAndPrint (fetchUrl, $printContainer) {
        fetch(fetchUrl, {
            method: 'POST',
            body: new FormData(this.$form)
        })
            .then(response => response.text())
            .then(data => {
                const parser = new DOMParser();
                const parsedData = parser.parseFromString(data, 'text/html');

                const $mainContent = parsedData.querySelector('[data-main-content]');

                if ($mainContent) {
                    this.print($printContainer, $mainContent.innerHTML);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    print ($printContainer, content) {
        const scrollPositionY = window.scrollY;

        window.addEventListener('afterprint', () => {
            $printContainer.innerHTML = '';
            window.scrollTo({ top: scrollPositionY, behavior: 'instant' });
        }, { once: true });

        $printContainer.innerHTML = content;
        window.print();
    }
}

export { TravelExtensionDetails };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-travel-extension-details="root"]');

        $$roots.forEach($root => {
            const $rootAPI = new TravelExtensionDetails($root);
            $rootAPI.initialize();
        });
    }
});
